<template>
    <main class="login">
        <div class="page-header">
            <h1 class="page-header__title">Logowanie</h1>
        </div>
        <transition name="fade">
            <Credentials v-if="step === 'credentials'" @nextStep="nextStep($event)"/>
            <Code v-if="step === 'code'"/>
            <ResetPasswordRequest v-if="step === 'resetPassword'"/>
        </transition>
    </main>
</template>

<script>
import Credentials from "@/components/login/Credentials";
import Code from "@/components/login/Code";
import ResetPasswordRequest from "@/components/login/ResetPasswordRequest";

export default {
    name: "Login",
    components: {
        Credentials,
        Code,
        ResetPasswordRequest
    },
    data() {
        return {
            step: "credentials"
        };
    },
    methods: {
        nextStep(nextStep) {
            this.step = nextStep;
        }
    }
};
</script>

<style lang="scss">
.login {
    flex: 1;

    &-actions {
        text-align: center;
        font-size: 14px;
        margin-top: 30px;
        flex-wrap: nowrap;

        &__item {
            flex: 1;
        }

        &__link {
            font-weight: bold;
            color: #85b904;
            cursor: pointer;
        }
    }

    &__row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        margin: 12px 0;
        position: relative;

        &--margin {
            margin-top: 20px;
        }

        input {
            padding: 0 0 0 40px !important;
        }

        img {
            position: absolute;
            left: 13px;
            top: 8px;
        }
    }
}
</style>
